// eslint-disable-next-line no-restricted-imports
import type { SavedSearchModel } from 'app/gamma/src/types/models';
// eslint-disable-next-line no-restricted-imports
import type { SavedSearchResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import genericNormalizer from 'app/gamma/src/api/normalizers/generic';

// eslint-disable-next-line @trello/no-module-logic
export const normalizeSavedSearch = genericNormalizer<
  SavedSearchResponse,
  SavedSearchModel
>(({ from }) => ({
  id: from('id'),
  name: from('name'),
  pos: from('pos'),
  query: from('query'),
}));
